var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batch-preview-notice",attrs:{"role":"note"}},[_c('i',{staticClass:"el-icon-info",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(_vm.notice))])])
}
var staticRenderFns = []

export { render, staticRenderFns }